export const MARKETING_MATERIALS = [
  {
    id: 'fastStart',
    images: {
      ru: '/assets/img/marketing-materials/fast-start-ru.png',
      en: '/assets/img/marketing-materials/fast-start-en.png',
      bg: '/assets/img/marketing-materials/fast-start-bg.png',
    },
  },
  {
    id: 'matchingBonus',
    images: {
      ru: '/assets/img/marketing-materials/matching-bonus-ru.png',
      en: '/assets/img/marketing-materials/matching-bonus-en.png',
      bg: '/assets/img/marketing-materials/matching-bonus-bg.png',
    },
  },
  {
    id: 'units',
    images: {
      ru: '/assets/img/marketing-materials/units-ru.png',
      en: '/assets/img/marketing-materials/units-en.png',
      bg: '/assets/img/marketing-materials/units-bg.png',
    },
  },
  {
    id: 'career',
    images: {
      ru: '/assets/img/marketing-materials/career-ru.png',
      en: '/assets/img/marketing-materials/career-en.png',
      bg: '/assets/img/marketing-materials/career-bg.png',
    },
  },
];

export const getMarketingMaterialImage = (material, language) =>
  material.images[language] || material.images.ru;
